const subjectKnowledgeUrl = 'subject-knowledge';

export default subjectKnowledgeUrl;
